import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'
import FieldsReport from 'graphql/fields/FieldsReport'

const fields = {
	'active': '[String]',
};

export default gql(`
	query reports( ${ HelperGraphql.createFields( fields ) } ) {
		reports( ${ HelperGraphql.createVariables( fields ) } ) {
			${ FieldsReport }
		}
	}
`);

